import { useEffect } from 'react';

const useMouseSpotlight = () => {
  useEffect(() => {
    let animationId = null;
    
    const handleMouseMove = (e) => {
      // Validar que el evento existe
      if (!e || !e.target) return;
      
      // Cancelar la animación anterior si existe
      if (animationId) {
        cancelAnimationFrame(animationId);
      }
      
      // Usar requestAnimationFrame para mejor rendimiento
      animationId = requestAnimationFrame(() => {
        try {
          // Buscar .card, .certificate-card o .contact-form-spotlight
          let target = e.target.closest('.card');
          if (!target) {
            target = e.target.closest('.certificate-card');
          }
          if (!target) {
            target = e.target.closest('.contact-form-spotlight');
          }
          
          if (target && target.getBoundingClientRect) {
            const rect = target.getBoundingClientRect();
            
            // Validar que tenemos coordenadas válidas
            if (typeof e.clientX === 'number' && typeof e.clientY === 'number' && 
                rect.width > 0 && rect.height > 0) {
              
              // Calcular la posición del mouse relativa a la card
              const x = e.clientX - rect.left;
              const y = e.clientY - rect.top;
              
              // Convertir a porcentajes
              const xPercent = Math.max(0, Math.min(100, (x / rect.width) * 100));
              const yPercent = Math.max(0, Math.min(100, (y / rect.height) * 100));
              
              // Actualizar las variables CSS solo para la card actual
              target.style.setProperty('--mouse-x', `${xPercent}%`);
              target.style.setProperty('--mouse-y', `${yPercent}%`);
            }
          }
        } catch (error) {
          console.warn('Error in mouse spotlight effect:', error);
        }
      });
    };

    const handleMouseEnter = (e) => {
      if (e.target && e.target.classList) {
        if (e.target.classList.contains('card') || e.target.classList.contains('certificate-card')) {
          e.target.classList.add('card-spotlight-active');
        } else if (e.target.classList.contains('contact-form-spotlight')) {
          e.target.classList.add('form-spotlight-active');
        }
      }
    };

    const handleMouseLeave = (e) => {
      if (e.target && e.target.classList) {
        if (e.target.classList.contains('card') || e.target.classList.contains('certificate-card')) {
          e.target.classList.remove('card-spotlight-active');
          // Resetear a la posición central cuando el mouse sale
          e.target.style.setProperty('--mouse-x', '50%');
          e.target.style.setProperty('--mouse-y', '50%');
        } else if (e.target.classList.contains('contact-form-spotlight')) {
          e.target.classList.remove('form-spotlight-active');
          // Resetear a la posición central cuando el mouse sale
          e.target.style.setProperty('--mouse-x', '50%');
          e.target.style.setProperty('--mouse-y', '50%');
        }
      }
    };

    // Agregar event listeners
    document.addEventListener('mousemove', handleMouseMove, { passive: true });
    document.addEventListener('mouseenter', handleMouseEnter, true);
    document.addEventListener('mouseleave', handleMouseLeave, true);

    // Cleanup
    return () => {
      if (animationId) {
        cancelAnimationFrame(animationId);
      }
      document.removeEventListener('mousemove', handleMouseMove);
      document.removeEventListener('mouseenter', handleMouseEnter, true);
      document.removeEventListener('mouseleave', handleMouseLeave, true);
    };
  }, []);
};

export default useMouseSpotlight;
